'use strict';

export default class PageNodeTypeWork {
  constructor() {
    this.name = 'page-node-type-work';
    
      // if ($(window).width() < 768) { // Adjust the value (768) to the desired breakpoint.
      //   $("#portfolio-view").attr("open", "");
      // } else {
      //   $("#portfolio-view").removeAttr("open");
      // }
  }
}
